module.exports = __webpack_public_path__ + "img/thso-icon.cc4746e3.png";